// All editable site copy lives here.
export const TIKTOK_URL = "https://www.tiktok.com/@philosophiles";
export const SUPPORT_URL = "https://donate.stripe.com/14A14m3TVcF36zM9s4a7C00";

export const nav = [
  { label: "Our goal", href: "#goal", testId: "nav-link-our-goal" },
  { label: "Our founding question", href: "#founding-question", testId: "nav-link-founding-question" },
  { label: "App preview", href: "#preview", testId: "nav-link-app-preview" },
  { label: "What’s next", href: "#next", testId: "nav-link-whats-next" },
];

export const hero = {
  eyebrow: "A philosophy community, just beginning",
  lines: ["Think deeper.", "See bigger."],
  body: "A little philosophy for everyday life. Explore new ideas, understand yourself, and question the world around you.",
  primary: "Our founding question",
  secondary: "Meet Philosophiles",
};

export const marquee = [
  "What makes a life feel like your own?",
  "Who would you be without your job title?",
  "What do we owe the people we disagree with?",
  "Is ambition a compass or a cage?",
  "Which of your beliefs did you actually choose?",
  "What is enough?",
];

export const goal = {
  eyebrow: "Our goal",
  heading: "Big questions belong in everyday life.",
  paragraphs: [
    "It’s easy to get caught up in the next grade, paycheck, or milestone without asking what we’re working toward. Philosophiles creates space to pause, explore a different perspective, and think about what matters to us.",
    "We want to make philosophy part of everyday life through accessible ideas, honest reflection, and conversations that welcome disagreement. You don’t need a philosophy degree or a perfect answer. Curiosity is enough.",
  ],
  themes: [
    { title: "Learn something new", text: "Explore ideas that challenge your assumptions." },
    { title: "Understand yourself", text: "Examine your values, ambitions, and reactions." },
    { title: "Find perspective", text: "Step back and consider the bigger picture." },
  ],
};

export const founding = {
  eyebrow: "Our founding question",
  heading: "What makes something worth devoting your life to?",
  opening: "A career can give us direction, security, and something to work toward. But choosing a path also means choosing where to put our time, attention, and care. What do we hope will grow from that commitment?",
  button: "Why I’m building Philosophiles",
  reflectionLabel: "A personal reflection from our founder",
  reflection: [
    "I’ve spent much of my time focused on business and imagining the career I could build. Along the way, I started questioning whether that commitment fully reflected who I am. I’m interested in building something, but I want what I build to nourish others—to encourage curiosity, offer perspective, and help people understand themselves.",
    "Philosophiles is a seed of that idea. I don’t know everything it will become. I know that I want to give it the care and patience to find out.",
  ],
  closing: "What would you choose to grow—and why would it be worth your care?",
  note: "This is the question behind our beginning. As Philosophiles grows, we hope to bring you more prompts that invite reflection on yourself and the world around you.",
};

export const building = {
  eyebrow: "What’s next",
  heading: "A home for curious minds.",
  intro: "Philosophiles is just beginning. Here’s the experience we’re working toward.",
  tag: "Planned",
  items: [
    "Short daily ideas and creator perspectives.",
    "Private reflection and opportunities to revisit your thinking.",
    "Thoughtful community discussion.",
    "Real-world conversations and videos exploring philosophical questions.",
  ],
  note: "We’re also exploring limited-edition collections inspired by philosophical themes, with the possibility of supporting related nonprofit causes.",
};

export const follow = {
  eyebrow: "Available now",
  heading: "Be here from the beginning.",
  body: "We’re starting with questions worth carrying into your day. Follow @philosophiles on TikTok and help shape what comes next.",
  button: "Follow @philosophiles",
};

export const preview = {
  eyebrow: "In development",
  heading: "Phind your meaning. Phind your people.",
  intro: "We’re building a space where one daily question can open up a bigger conversation—about what you believe, how you understand yourself, and what you might discover by listening to someone else. Here’s a first look at Philosophiles as it takes shape.",
  status: "Actual screenshots from our early app prototype. Features and design may change as we test and develop.",
  workingLabel: "What we’re working toward",
  working: "Our next steps include refining the daily experience, testing with early users, and adding team reflection videos pinned beneath the daily question to offer another perspective after you respond.",
  shots: [
    {
      key: "today",
      label: "Today",
      title: "Start with a question.",
      text: "A shared Daily Inquisition invites you to pause, examine a dilemma, and put your perspective into words. Take a moment to think for yourself before exploring how others see it.",
      img: "/brand/app-today.webp",
      alt: "Prototype screenshot of the Daily Inquisition screen, showing today’s shared dilemma and space to form your own response",
    },
    {
      key: "community",
      label: "Community",
      title: "Discover another perspective.",
      text: "Explore public reflections around the same question. The app is being designed to offer optional one-on-one discussions with people who take a contrasting stance—creating room to understand why you disagree.",
      img: "/brand/app-community.webp",
      alt: "Prototype screenshot of the Community screen, with public reflections around the same daily question and matched discussion options",
    },
    {
      key: "profile",
      label: "Profile",
      title: "Make room for growth.",
      text: "Build your profile, explore philosophical traditions, and revisit your reflections. Personal tools include a private reflection calendar, public responses, private reflections, and connections called Philosopals.",
      img: "/brand/app-profile.webp",
      alt: "Prototype screenshot of the Profile screen, with a reflection calendar, public responses, private reflections, and Philosopals connections",
    },
    {
      key: "feedback",
      label: "Feedback",
      title: "Help shape what comes next.",
      text: "Philosophiles is still taking shape. The feedback section gives early participants a place to suggest ideas, report problems, and tell us what would make the experience more meaningful.",
      img: "/brand/app-feedback.webp",
      alt: "Prototype screenshot of the Feedback screen, where early participants can suggest ideas, report problems, or share general feedback",
    },
  ],
};

export const support = {
  eyebrow: "Support Philosophiles",
  heading: "Help this idea grow.",
  body: "Your optional support helps us maintain the website and pursue app development. Sharing Philosophiles and offering thoughtful feedback also help us move forward.",
  button: "Support Philosophiles",
  secondary: "Explore our mission",
  note: "Optional, one-time support for our freely available content. No products, paid access, ownership, or future benefits are included. This is not a charitable donation.",
};

export const thanks = {
  heading: "Thank you for helping this idea grow.",
  body: "Your support is optional and deeply appreciated—it goes toward the website, the content, and the care this idea needs to grow. Either way, we’re glad you’re here.",
  button: "Back to the ideas",
  tiktokPre: "Feel like saying hello? We’re sharing the journey on TikTok at",
};

export const footer = {
  signoff: "For the love of philosophy.",
  link: "TikTok · @philosophiles",
};
